import {
  componentNameConstants,
  dlEventConstants,
  headerConstants,
} from "@repo/analytics/data-layer.constants";
import { DataLayerProps } from "@repo/analytics/data-layer-utils";
import { trackAnalyticsEvent } from "../../utils/AnalyticsUtils";

/**
 * FooterAppDownloadFunction.ts
 * Analytics handler for Footer App Download button clicks
 */

// Analytics event handler for Footer App Download click
export function handleFooterAppDownloadClickDL(
  loginStatus: string,
  destination_url: string,
  platform: string,
  cta_text: string
) {
  // Create analytics data object

  const data: DataLayerProps = {
    component: componentNameConstants.FOOTER_COMPONENT,
    event: "icon",
    event_type: dlEventConstants.CLICK,
    element: headerConstants.EVENT_NAMES.FOOTER_DOWNLOAD_ICON_CLICK,
    cta_text: cta_text,
    section_title: "footer",
    sub_section: "NA",
    destination_url,
  };

  trackAnalyticsEvent(data, undefined, "FooterDownloadIcon");
}
